<template>
    <div id="flash_sale" class="flash_sale">
        <div class="flash_sale_part text-1">Flash SALE</div>
        <div class="flash_sale_center">
            <img class="flash_sale_img" :src="flashImg" alt="flash-sale" />
        </div>
        <div class="pdp_flash_sale_right">
            <div class="flash_sale_part text-2">
                <span>Sale ends&nbsp;in</span>
            </div>
            <div class="wrapper-countdown-sale flash_sale_part">
                <div  class="countdown " :data-datesale="shortTermEnd"></div>
            </div>
        </div>
    </div>
</template>
<script lang="ts" setup>
    // import flashImg from '@/assets/images/single-product/flash.png';
    const flashImg = "https://www.skjewellery.com.my/api/wp-content/uploads/2023/11/flash-sale-thunder-134x300-1.png";
    const props = defineProps(['data']);
    const shortTermData = props.data;

    const shortTermEnd = computed(() => props.data.end_date);

    const emmCountDownSale = () => {
        const countdownElements = document.querySelectorAll(".countdown");

        if (countdownElements.length > 0) {
            countdownElements.forEach((element) => {
                if (element instanceof HTMLElement && element.classList.contains("countdown")) {
                    const targetDateString = element.getAttribute("data-datesale");
                    if (!targetDateString) return;

                    const targetDate = new Date(targetDateString);

                    const countdownInterval = setInterval(() => {
                        const singaporeTime = new Date(new Date().toLocaleString("en-US", { timeZone: "Asia/Singapore" }));
                        const now = singaporeTime;

                        const timeRemaining = targetDate.getTime() - now.getTime();
                        if (timeRemaining > 0) {
                            const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24)).toString().padStart(2, '0');
                            const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)).toString().padStart(2, '0');
                            const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60)).toString().padStart(2, '0');
                            const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000).toString().padStart(2, '0');

                            element.innerHTML = `
                                <div class="countdown-item"><span>${days}</span>Day</div>
                                <div class="countdown-item"><span>${hours}</span>Hrs</div>
                                <div class="countdown-item"><span>${minutes}</span>Mins</div>
                                <div class="countdown-item"><span>${seconds}</span>Secs</div>
                            `;
                        } else {
                            const flashSaleParent = element.closest('.flash_sale');
                            if (flashSaleParent instanceof HTMLElement) {
                                flashSaleParent.style.display = "none";
                            }
                            clearInterval(countdownInterval);
                        }
                    }, 1000);
                }
            });
        }
    }
    onMounted(() => {
        emmCountDownSale();
    });
</script>